// src/components/Swipeable.jsx
import React from "react";
import {useSwipeable} from "react-swipeable";

export default function Swipeable({
                                      children,
                                      onSwipedLeft,
                                      onSwipedRight,
                                      onSwipedUp,
                                      onSwipedDown,
                                      trackMouse = false,   // ← можно задавать снаружи
                                      ...restProps          // всё остальное (className, style и т.д.)
                                  }) {
    const handlers = useSwipeable({
        onSwipedLeft,
        onSwipedRight,
        onSwipedUp,
        onSwipedDown,
        trackMouse,                   // ← используем здесь
        preventScrollOnSwipe: true,
        trackTouch: true,
    });

    return (
        <div {...handlers} {...restProps}>
            {children}
        </div>
    );
}
